import { apiRequest } from "./client";

export const pushApi = {
  status(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/push`, { params });
  },
  adoption(projectId, payload) {
    return apiRequest(`/projects/${projectId}/push/adoption`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  subscribe(projectId, subscription, preferences = {}) {
    return apiRequest(`/projects/${projectId}/push/subscribe`, {
      method: "POST",
      body: JSON.stringify({ subscription, preferences }),
    });
  },
  unsubscribe(projectId, endpoint) {
    return apiRequest(`/projects/${projectId}/push/subscribe`, {
      method: "DELETE",
      body: JSON.stringify({ endpoint }),
    });
  },
  send(projectId, payload) {
    return apiRequest(`/projects/${projectId}/push/send`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
